import ReactPlayer from 'react-player/lazy';
import PropTypes from 'prop-types';

const VideoPlayer = ({
  width, height, url, noControls, config,
}) => {
  const extractVideoId = (embeddedUrl) => {
    if (!embeddedUrl) return null;

    try {
      const urlObj = new URL(embeddedUrl);
      if (urlObj.pathname.includes('/embed/')) {
        const parts = urlObj.pathname.split('/');
        return parts[parts.length - 1];
      }
      return null;
    } catch (error) {
      return null;
    }
  };

  const videoId = extractVideoId(url);
  const directUrl = videoId
    ? `https://www.youtube.com/watch?v=${videoId}`
    : url;

  const playerConfig = {
    file: {
      attributes: {
        style: {
          width,
          objectFit: 'cover',
          borderRadius: 5,
        },
      },
    },
  };

  return (
    // eslint-disable-next-line react/jsx-filename-extension
    <ReactPlayer
      url={directUrl}
      width={width}
      height={height}
      controls={!noControls}
      config={config || playerConfig}
      playing
      light
    />
  );
};
VideoPlayer.propTypes = {
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  url: PropTypes.string.isRequired,
  noControls: PropTypes.bool,
  config: PropTypes.shape({}),
};

VideoPlayer.defaultProps = {
  noControls: false,
  config: {},
};

export default VideoPlayer;
